import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemperatureOff = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18 11.8V4C18 3.20435 17.6839 2.44129 17.1213 1.87868C16.5587 1.31607 15.7957 1 15 1C14.2044 1 13.4413 1.31607 12.8787 1.87868C12.3161 2.44129 12 3.20435 12 4V11.8C10.8562 12.4604 9.96218 13.4798 9.45673 14.7001C8.95127 15.9203 8.8626 17.2733 9.20445 18.5491C9.5463 19.8249 10.2996 20.9522 11.3474 21.7563C12.3953 22.5603 13.6792 22.9962 15 22.9962C16.3208 22.9962 17.6047 22.5603 18.6526 21.7563C19.7004 20.9522 20.4537 19.8249 20.7956 18.5491C21.1374 17.2733 21.0487 15.9203 20.5433 14.7001C20.0378 13.4798 19.1439 12.4604 18 11.8Z",
			stroke: "#808999",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 20C15.7956 20 16.5587 19.6839 17.1213 19.1213C17.4454 18.7972 17.6877 18.4066 17.8349 17.9816C18.0156 17.4597 17.5523 17 17 17H13C12.4477 17 11.9844 17.4597 12.1651 17.9816C12.3123 18.4066 12.5546 18.7972 12.8787 19.1213C13.4413 19.6839 14.2044 20 15 20Z",
			fill: "#808999"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 3H3",
			stroke: "#808999",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 8H3",
			stroke: "#808999",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 13H3",
			stroke: "#808999",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 22.8411,
			y1: 6.04869,
			x2: 5.04869,
			y2: 19.1589,
			stroke: "#808999",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgTemperatureOff;
